export const enum SeatDistribution{
    NONE = 0,
    NORMAL = 1,
    ODDS = 2,
    EVENS = 3,
    ODDS_TO_EVENS = 4,
    CENTER_ODDS_TO_EVENS = 5,
    UPPER_CASE = 6,
    LOWER_CASE = 7
}

export const SEAT_LABEL_OPTIONS = [
    { value: SeatDistribution.NONE, label: "Seleccione tipo de distribución" },
    { value: SeatDistribution.NORMAL, label: "1, 2, 3, ..." },
    { value: SeatDistribution.ODDS, label: "1, 3, 5, ..." },
    { value: SeatDistribution.EVENS, label: "2, 4, 6, ..." },
    { value: SeatDistribution.ODDS_TO_EVENS, label: "1, 3, 5, ..., 6, 4, 2"},
    { value: SeatDistribution.CENTER_ODDS_TO_EVENS, label: "..., 5, 3, 1, 2, 4, 6, ..."},
    { value: SeatDistribution.UPPER_CASE, label: "A, B, C, ..."},
    { value: SeatDistribution.LOWER_CASE, label: "a, b, c, ..."},
];